// extracted by mini-css-extract-plugin
module.exports = {"customFileUpload":"styles-module--custom-file-upload--2TVTS"};